import { z } from 'zod';
/** Admin "AI translation settings" payload. Mirrors SystemController::updateAiSettings(). */
export const aiTranslationSettingsSchema = z.object({
    ai_blog_translation_system_prompt: z.string().min(50),
    ai_blog_translation_user_prompt: z.string().nullable().optional(),
});
//# sourceMappingURL=settings.js.map